import React, { FC } from 'react';
import FilterTag from './FilterTag';
import { FilterOption } from '../../types';

export interface FilterSectionProps {
  title: string;
  options: FilterOption[];
  selectedIds: string[];
  onToggle: (id: string) => void;
}

const FilterSection: FC<FilterSectionProps> = ({ title, options, selectedIds, onToggle }) => {
  return (
    <div className="p-filter__section">
      <div className="p-filter__section-title">{title}</div>
      <div className="p-filter__tags">
        {options.map((option) => (
          <FilterTag
            key={option.id}
            id={option.id}
            name={option.name}
            icon={option.icon}
            isActive={selectedIds.includes(option.id)}
            onClick={onToggle}
          />
        ))}
      </div>
    </div>
  );
};

export default FilterSection;
